import { storeCurRoute } from '../components/router/router';
/**
 * scrollToAnchor
 */
export function scrollToAnchor(anchor) {
    setTimeout(function () {
        if (anchor !== "") {
            const offsetTop = document.getElementById(anchor).offsetTop;
            const element = document.getElementById(anchor);
            element.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        }
        else {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }, 300);
}
;
/**
 * Mise à jour d'un cookie
 * @param name
 * @param value
 * @param days
 */
export function setCookie(name, value, days) {
    var name_value = name + "=" + (value || "");
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    var path = "; path=/";
    var domain = "; domain=" + window.location.hostname;
    document.cookie = name_value + expires + path + domain;
}
/**
 * Récupération de la valeur d'un cookie
 * @param name
 * @returns
 */
export function getCookie(name) {
    let cookie_value = "";
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {
            cookie_value = c.substring(nameEQ.length, c.length);
        }
    }
    return cookie_value;
}
/**
 * Suppression d'un cookie
 * pour les domaines : www.domain.ext et domain.ext
 * @param name
 */
export function eraseCookie(name) {
    var name_value = name + "=";
    var path = "; path=/";
    var expires = "; expires=Thu, 01 Jan 1970 00:00:01 GMT";
    var domain = "; domain=" + window.location.hostname;
    document.cookie = name_value + path + expires + domain;
    var domain_sans_www = "; domain=" + window.location.hostname.substring(4);
    document.cookie = name_value + path + expires + domain_sans_www;
}
export function sanitise_path(path) {
    var return_value = path;
    if (path == "/") {
        return_value = "/home";
    }
    else if (path.indexOf("#") >= 0) {
        return_value = "/home#" + path.substring(1, path.indexOf("#"));
    }
    return "körtefa" + return_value;
}
/**
 * redirectTo
 */
export function redirectTo(idPage, param = "") {
    storeCurRoute.set(idPage);
    window.history.pushState({ path: "#" + idPage }, '', window.location.origin + "/" + idPage + param);
    // COOKIE - deb
    // if ($is_analytics) {
    // 	path = sanitise_path(path);
    // 	window.gtag('event', 'page_view', {
    // 		page_title: path,
    // 		page_location: '<Page Location>',
    // 		page_path: '<Page Path>',
    // 	})
    // }
    // COOKIE - fin
}
/**
 * historyNavigation
 * Écoute de l’événement popstate qui est lancé lorsque l’historique change.
 * Le clic sur le back du navigateur est écouté et la route courante actualisée
 *
 * @param event
 */
export function historyNavigation(event) {
    // change current router path
    if (event.state.path.indexOf("#") >= 0 && storeCurRoute != undefined) {
        storeCurRoute.set(event.state.path.replace('#', ''));
    }
}
/**
 * redirection
 * url = https://www.truc.com/page?id=n
 */
export function redirection() {
    const url = new URL(window.location.href);
    const splitUrl = url.href.split("/");
    let page = "";
    if (splitUrl.length > 3 && splitUrl[3].length > 0) {
        const splitPage = splitUrl[3].split("?");
        page = splitPage[0];
        const urlParams = new URLSearchParams(window.location.search);
        const params = updateStoreFromUrl(page, urlParams);
        redirectTo(page, params);
    }
}
function updateStoreFromUrl(page, urlParams) {
    let paramUrl = "";
    return paramUrl;
}
